export const formatRoundedCurrency = (locale, currency, number) =>
  Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(number)

export const getCompactCurrency = (locale, currency, number) =>
  Intl.NumberFormat(locale, {
    notation: 'compact',
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    maximumSignificantDigits: 3,
  }).format(number)
